import type React from "react";
// Shared with mobile via frontend/packages/assets — reached by relative path,
// the same way the locale flags are.
import { ReactComponent as RecommendSessionIcon } from "../../../../../../../../packages/assets/chat-starters/recommend-session.svg";
import { ReactComponent as ScoresMeaningIcon } from "../../../../../../../../packages/assets/chat-starters/scores-meaning.svg";
import { ReactComponent as SleepBetterIcon } from "../../../../../../../../packages/assets/chat-starters/sleep-better.svg";
import { ReactComponent as StressPatternsIcon } from "../../../../../../../../packages/assets/chat-starters/stress-patterns.svg";
import { ReactComponent as StressfulSituationIcon } from "../../../../../../../../packages/assets/chat-starters/stressful-situation.svg";
import type { GenericStarterId } from "../chat-starters";

/**
 * One icon per generic starter, keyed by id rather than position — the set
 * is shuffled on every display. Coach's own starters carry no icon.
 */
export const GENERIC_STARTER_ICONS: Record<
  GenericStarterId,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  recommendSession: RecommendSessionIcon,
  stressfulSituation: StressfulSituationIcon,
  sleepBetter: SleepBetterIcon,
  scoresMeaning: ScoresMeaningIcon,
  stressPatterns: StressPatternsIcon,
};
